



















































































































































import 'reflect-metadata'
import { Component, Vue, Watch } from 'vue-property-decorator'
import BreadcrumbsPath from "@/components/common/breadcrumbs/BreadcrumbsPath.vue"
import Notification from "@/components/common/notification/Notification.vue"
import { ReportApi, ProjectApi, UnitApi, MasterDataApi  } from '@/api'

//component
import DropDownManageUnit from "@/components/common/combobox/DropDownManageUnitMulitiple.vue"
import DropDownMulitiple from "@/components/common/combobox/DropDownMulitiple.vue"
import DataTableBankCredit, { IDataTableBankCredit } from "@/components/report/datatable/DataTableBankCredit.vue"
import DropDownFixData from "@/components/common/combobox/DropDownFixData.vue"
import DropDownProjectMultiple from "@/components/common/combobox/DropDownProjectMultiple.vue"
import DatePickerFromTo from "@/components/common/date-picker/DatePickerFromTo.vue"
import { AuthenticateApi, PlanningTransferApi } from "@/api"
import { namespace } from 'vuex-class'

import XLSX from 'xlsx-js-style' 
import dayjs from 'dayjs'
import { VLayout } from 'vuetify/lib'

const Auth = namespace('authentication')

@Component({
    components: {
        DropDownManageUnit,
        'common-date-picker-dropdownfixdata': DropDownFixData,
        DataTableBankCredit,
        DropDownMulitiple,
        Notification,
        BreadcrumbsPath,
        DropDownProjectMultiple,
        DatePickerFromTo
    }
})
export default class BankCredit extends Vue { 
    breadcrumbs = [
        { text: 'Report' },
        { text: 'Bank Report' }
    ]

    panel = 0
    projectLists = [] as any
    projectOriginalLists = [] as any

    loading = false
    jsonData = {
        projectZone: [],
        projectId: "",
        projectName: [],
        productType: "",
        creditStatus: "",
        bank: [],
        unitSelectType: "unitAll",
        unitSelected: [],
        unitFrom: "",
        unitTo: "",
        dateFrom: null,
        dateTo: null
    } as any

    @Auth.State('auth') auth!: any

    tableShow = false

    unitLists = [] as any[]
    bankLists = [] as any[]
    creditStatusLists = [] as any[]
    creditReasonStatusLists = [] as any[]
    projectZoneLists = []

    @Watch("jsonData.projectZone")
    async onProjectZoneChange(val: string[], oldVal: string[]) {
        console.log('test', val)
        this.loading = true
        if (val === undefined || val === null) {
            this.openNotification("กรุณากรอกชื่อโครงการให้ถูกต้อง", "warning")
            this.loading = false
            return 
        }
        if (val.length > 0) {
            // Filter โครงการที่ projectZoneCode ตรงกับ zone ที่เลือก
            this.projectLists = this.projectOriginalLists.filter((x: any) => val.includes(x.projectZoneCode))
        } else {
            this.projectLists = this.projectOriginalLists
        }
        
        this.loading = false
    }

    @Watch("jsonData.projectId")
    async onProjectIdChange(val: any[], oldVal: string) {
        this.loading = true
        if (val === undefined) {
            this.openNotification("กรุณากรอกชื่อโครงการให้ถูกต้อง", "warning")
            this.loading = false
            return 
        }
        if (val.length === 1) {
            this.unitLists = await UnitApi.GetUnitListsByProjectId(val[0])
        } else {
            this.unitLists = []
        }
        this.loading = false
    }

    created () {
		this.startup()
	}

    async startup () {
        this.loading = true

        const getUserInfo = await AuthenticateApi.GetUserInfo()
            const hasMatchingPermission = getUserInfo?.permission.filter((filter) => filter.profileCode === "TFP-08" );

            if (hasMatchingPermission && hasMatchingPermission?.length <= 0) {
                localStorage.clear()
                window.location.reload()
            }

        this.projectOriginalLists = await ProjectApi.GetProjectLists()
        this.projectLists = this.projectOriginalLists
        console.log( "projectList ", this.projectLists)
        this.bankLists = (await MasterDataApi.GetMasterDataBank()).sort((a: any, b: any) => a.id - b.id)
        this.creditStatusLists = await MasterDataApi.GetMasterDataVlookUptpl1ByType("CreditStatus")
        this.creditReasonStatusLists = await MasterDataApi.GetMasterDataCreditReasonStatusByCreditStatusId(3)
        let projectZoneLists = await MasterDataApi.GetProjectZone() ?? []
        if (projectZoneLists!.length > 0 && projectZoneLists != undefined) {
            this.projectZoneLists = projectZoneLists.map((x: any, index: any) => ({ id: x.code, name: x.description, value: x.code}))
            console.log('this.projectZoneLists', this.projectZoneLists)
        }
        this.loading = false
    }

    async btnSearch () {
        this.loading = true
        try {

            const jsonParamsSearch = {
                projectId: this.jsonData.projectId == "" ? [] : this.jsonData.projectId,
                projectZone: this.jsonData.projectZone == "" ? [] : this.jsonData.projectZone,
                bank: this.jsonData.bank,
                creditStatus: `${this.jsonData.creditStatus}`,
                dateFrom: this.jsonData.dateFrom,
                dateTo: this.jsonData.dateTo,
                unitSelectType: this.jsonData.unitSelectType,
                unitSelected: this.jsonData.unitSelected,
                unitFrom: this.jsonData.unitFrom,
                unitTo: this.jsonData.unitTo,
            }

            // ต้องเลือก ProjectZone หรือ Project
            if ((!this.jsonData.projectZone?.length || this.jsonData.projectZone?.length === 0) && (!this.jsonData.projectId?.length || this.jsonData.projectId?.length === 0)) {
                this.openNotification('กรุณาเลือก ProjectZone หรือ เลือกโครงการ', 'warning')
                this.loading = false
                return
            }

            if (jsonParamsSearch.projectZone?.length > 0 && jsonParamsSearch.projectId?.length == 0 && jsonParamsSearch.dateFrom == null) {
                this.openNotification('กรุณาเลือก วันโอนกรรมสิทธิ์ หรือ Export Excel', 'warning')
                this.loading = false
                return
            }

            const dataItem = await this.getReportBankCredit()

            let projectNames = this.projectLists
                .filter((project:any) => this.jsonData.projectId.includes(String(project.id)))
                .map((project:any) => project.name);

            this.jsonData.projectName = projectNames

            const logModel = {
                    application_name: "Transfer_Planning",
                    feature: "btnSearch Data Found : " + dataItem.length.toString() + " Records",
                    page: "Bank Report",
                    json_data: JSON.stringify(this.jsonData),
                    created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            if (dataItem.length > 0) {
                const refDataTableBankCredit = this.$refs.refDataTableBankCredit as DataTableBankCredit
                refDataTableBankCredit.setDataTable(dataItem)
                this.tableShow = true
            } else {
                this.tableShow = false
            }

            this.loading = false
            return
        } catch (error) {
            this.openNotification('ไม่สามารถค้นหาข้อมูลได้ กรุณาลองใหม่', 'warning') 
            this.loading = false
        }
    }  

    async btnExportExcel () {
        this.loading = true
        try {

            const jsonParamsSearch = {
                projectId: this.jsonData.projectId == "" ? [] : this.jsonData.projectId,
                projectZone: this.jsonData.projectZone,
                bank: this.jsonData.bank,
                creditStatus: `${this.jsonData.creditStatus}`,
                dateFrom: this.jsonData.dateFrom,
                dateTo: this.jsonData.dateTo,
                unitSelectType: this.jsonData.unitSelectType,
                unitSelected: this.jsonData.unitSelected,
                unitFrom: this.jsonData.unitFrom,
                unitTo: this.jsonData.unitTo,
            }

            // ต้องเลือก ProjectZone หรือ Project
            if ((!this.jsonData.projectZone?.length || this.jsonData.projectZone?.length === 0) && (!this.jsonData.projectId?.length || this.jsonData.projectId?.length === 0)) {
                this.openNotification('กรุณาเลือก ProjectZone หรือ เลือกโครงการ', 'warning')
                this.loading = false
                return
            }

            const logModel = {
                    application_name: "Transfer_Planning",
                    feature: "btnExportExcel Data Export",
                    page: "Bank Report",
                    json_data: JSON.stringify(jsonParamsSearch),
                    created_by: this.auth.username,
                };
            PlanningTransferApi.addLog(logModel)

            let getReportBankCredit = await ReportApi.GetReportBankCreditExcel(jsonParamsSearch)

            // Download file from blob
            const blob = new Blob([getReportBankCredit], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `BankCreditReport_${dayjs().format('YYYYMMDDHHmmss')}.xlsx`)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)

            this.openNotification('Export Excel สำเร็จ', 'success')
        
            this.loading = false
            return
        } catch (error) {
            console.log('error', error)
            this.openNotification('ไม่สามารถ Export Excel ได้ กรุณาลองใหม่', 'error') 
            this.loading = false
        }
    }

    async getReportBankCredit () {

        this.loading = true

        const jsonParamsSearch = {
            projectId: this.jsonData.projectId == "" ? [] : this.jsonData.projectId,
            projectZone: this.jsonData.projectZone,
            bank: this.jsonData.bank,
            creditStatus: `${this.jsonData.creditStatus}`,
            dateFrom: this.jsonData.dateFrom,
            dateTo: this.jsonData.dateTo,
            unitSelectType: this.jsonData.unitSelectType,
            unitSelected: this.jsonData.unitSelected,
            unitFrom: this.jsonData.unitFrom,
            unitTo: this.jsonData.unitTo,
        }
        console.log('jsonParamsSearch', jsonParamsSearch)

        let getReportBankCredit: any[] = await ReportApi.GetReportBankCredit(jsonParamsSearch)

        const refDataTableBankCredit = this.$refs.refDataTableBankCredit as DataTableBankCredit

        if (getReportBankCredit.length <= 0) {
            this.openNotification('ไม่พบข้อมูลที่ค้นหา', 'warning') 
            refDataTableBankCredit.clearDataTable()
            this.loading = false
            return []
        }

        const unitCodeLists: any[] = [...new Set(getReportBankCredit.map((m: any) => (m.unitCode)))]
            const notBankIdLists = [15,2,12,1,345,4,10,11,14]
            const dataItem: any[] = []
            unitCodeLists.forEach((unitCode: any, index: number) => {
                let scbUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 15))
                let bblUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 2))
                let ktbUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 12))
                let kbankUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 1))
                let ttbUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 345))
                let bayUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 4))
                let ghbUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 10))
                let gsbUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 11))
                let uobUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && (g.bankId == 14))
                let otherUsedBank: any[] = getReportBankCredit.filter(g => g.unitCode == unitCode && notBankIdLists.includes(g.bankId) == false)
                let projectName: any[] = getReportBankCredit.filter(x => x.unitCode == unitCode)
                dataItem.push(
                    {
                        no: ++index,
                        unitCode: unitCode,
                        projectNameTh: projectName.length > 0 ? projectName[0].projectNameTH : "",
                        scbUsedBankId: scbUsedBank.length > 0 ? this.setUsedBank(scbUsedBank[0]) : "",
                        scbBankId: scbUsedBank.length > 0 ? this.setBank(scbUsedBank[0].bankId) : "",
                        scbApproveFinanceAmt: scbUsedBank.length > 0 ? this.setComma(scbUsedBank[0].approveFinanceAmt) : "",
                        scbInterest: scbUsedBank.length > 0 ? scbUsedBank[0].interest : "",
                        scbApproveCreditPercent: scbUsedBank.length > 0 ? scbUsedBank[0].approveCreditPercent : "",
                        scbCreditStatusId: scbUsedBank.length > 0 ? this.setCreditStatus(scbUsedBank[0].creditStatusId) : "",
                        scbCreditReasonStatusId: scbUsedBank.length > 0 ? this.setCreditReasonStatus(scbUsedBank[0].creditReasonStatusId) : "",
                        scbCrRemarkBank: scbUsedBank.length > 0 ? scbUsedBank[0].crRemarkBank : "",
                        scbRecoverDate: scbUsedBank.length > 0 ? scbUsedBank[0].recoverDate : "",
                        scbApproveDate: scbUsedBank.length > 0 ? scbUsedBank[0].approveDate : "",

                        bblUsedBankId: bblUsedBank.length > 0 ? this.setUsedBank(bblUsedBank[0]) : "",
                        bblBankId: bblUsedBank.length > 0 ? this.setBank(bblUsedBank[0].bankId) : "",
                        bblApproveFinanceAmt: bblUsedBank.length > 0 ? this.setComma(bblUsedBank[0].approveFinanceAmt) : "",
                        bblInterest: bblUsedBank.length > 0 ? bblUsedBank[0].interest : "",
                        bblApproveCreditPercent: bblUsedBank.length > 0 ? bblUsedBank[0].approveCreditPercent : "",
                        bblCreditStatusId: bblUsedBank.length > 0 ? this.setCreditStatus(bblUsedBank[0].creditStatusId) : "",
                        bblCreditReasonStatusId: bblUsedBank.length > 0 ? this.setCreditReasonStatus(bblUsedBank[0].creditReasonStatusId) : "",
                        bblCrRemarkBank: bblUsedBank.length > 0 ? bblUsedBank[0].crRemarkBank : "",
                        bblRecoverDate: bblUsedBank.length > 0 ? bblUsedBank[0].recoverDate : "",
                        bblApproveDate: bblUsedBank.length > 0 ? bblUsedBank[0].approveDate : "",

                        ktbUsedBankId: ktbUsedBank.length > 0 ? this.setUsedBank(ktbUsedBank[0]) : "",
                        ktbBankId: ktbUsedBank.length > 0 ? this.setBank(ktbUsedBank[0].bankId) : "",
                        ktbApproveFinanceAmt: ktbUsedBank.length > 0 ? this.setComma(ktbUsedBank[0].approveFinanceAmt) : "",
                        ktbInterest: ktbUsedBank.length > 0 ? ktbUsedBank[0].interest : "",
                        ktbApproveCreditPercent: ktbUsedBank.length > 0 ? ktbUsedBank[0].approveCreditPercent : "",
                        ktbCreditStatusId: ktbUsedBank.length > 0 ? this.setCreditStatus(ktbUsedBank[0].creditStatusId) : "",
                        ktbCreditReasonStatusId: ktbUsedBank.length > 0 ? this.setCreditReasonStatus(ktbUsedBank[0].creditReasonStatusId) : "",
                        ktbCrRemarkBank: ktbUsedBank.length > 0 ? ktbUsedBank[0].crRemarkBank : "",
                        ktbRecoverDate: ktbUsedBank.length > 0 ? ktbUsedBank[0].recoverDate : "",
                        ktbApproveDate: ktbUsedBank.length > 0 ? ktbUsedBank[0].approveDate : "",

                        kbankUsedBankId: kbankUsedBank.length > 0 ? this.setUsedBank(kbankUsedBank[0]) : "",
                        kbankBankId: kbankUsedBank.length > 0 ? this.setBank(kbankUsedBank[0].bankId) : "",
                        kbankApproveFinanceAmt: kbankUsedBank.length > 0 ? this.setComma(kbankUsedBank[0].approveFinanceAmt) : "",
                        kbankInterest: kbankUsedBank.length > 0 ? kbankUsedBank[0].interest : "",
                        kbankApproveCreditPercent: kbankUsedBank.length > 0 ? kbankUsedBank[0].approveCreditPercent : "",
                        kbankCreditStatusId: kbankUsedBank.length > 0 ? this.setCreditStatus(kbankUsedBank[0].creditStatusId) : "",
                        kbankCreditReasonStatusId: kbankUsedBank.length > 0 ? this.setCreditReasonStatus(kbankUsedBank[0].creditReasonStatusId) : "",
                        kbankCrRemarkBank: kbankUsedBank.length > 0 ? kbankUsedBank[0].crRemarkBank : "",
                        kbankRecoverDate: kbankUsedBank.length > 0 ? kbankUsedBank[0].recoverDate : "",
                        kbankApproveDate: kbankUsedBank.length > 0 ? kbankUsedBank[0].approveDate : "",

                        ttbUsedBankId: ttbUsedBank.length > 0 ? this.setUsedBank(ttbUsedBank[0]) : "",
                        ttbBankId: ttbUsedBank.length > 0 ? this.setBank(ttbUsedBank[0].bankId) : "",
                        ttbApproveFinanceAmt: ttbUsedBank.length > 0 ? this.setComma(ttbUsedBank[0].approveFinanceAmt) : "",
                        ttbInterest: ttbUsedBank.length > 0 ? ttbUsedBank[0].interest : "",
                        ttbApproveCreditPercent: ttbUsedBank.length > 0 ? ttbUsedBank[0].approveCreditPercent : "",
                        ttbCreditStatusId: ttbUsedBank.length > 0 ? this.setCreditStatus(ttbUsedBank[0].creditStatusId) : "",
                        ttbCreditReasonStatusId: ttbUsedBank.length > 0 ? this.setCreditReasonStatus(ttbUsedBank[0].creditReasonStatusId) : "",
                        ttbCrRemarkBank: ttbUsedBank.length > 0 ? ttbUsedBank[0].crRemarkBank : "",
                        ttbRecoverDate: ttbUsedBank.length > 0 ? ttbUsedBank[0].recoverDate : "",
                        ttbApproveDate: ttbUsedBank.length > 0 ? ttbUsedBank[0].approveDate : "",

                        bayUsedBankId: bayUsedBank.length > 0 ? this.setUsedBank(bayUsedBank[0]) : "",
                        bayBankId: bayUsedBank.length > 0 ? this.setBank(bayUsedBank[0].bankId) : "",
                        bayApproveFinanceAmt: bayUsedBank.length > 0 ? this.setComma(bayUsedBank[0].approveFinanceAmt) : "",
                        bayInterest: bayUsedBank.length > 0 ? bayUsedBank[0].interest : "",
                        bayApproveCreditPercent: bayUsedBank.length > 0 ? bayUsedBank[0].approveCreditPercent : "",
                        bayCreditStatusId: bayUsedBank.length > 0 ? this.setCreditStatus(bayUsedBank[0].creditStatusId) : "",
                        bayCreditReasonStatusId: bayUsedBank.length > 0 ? this.setCreditReasonStatus(bayUsedBank[0].creditReasonStatusId) : "",
                        bayCrRemarkBank: bayUsedBank.length > 0 ? bayUsedBank[0].crRemarkBank : "",
                        bayRecoverDate: bayUsedBank.length > 0 ? bayUsedBank[0].recoverDate : "",
                        bayApproveDate: bayUsedBank.length > 0 ? bayUsedBank[0].approveDate : "",

                        ghbUsedBankId: ghbUsedBank.length > 0 ? this.setUsedBank(ghbUsedBank[0]) : "",
                        ghbBankId: ghbUsedBank.length > 0 ? this.setBank(ghbUsedBank[0].bankId) : "",
                        ghbApproveFinanceAmt: ghbUsedBank.length > 0 ? this.setComma(ghbUsedBank[0].approveFinanceAmt) : "",
                        ghbInterest: ghbUsedBank.length > 0 ? ghbUsedBank[0].interest : "",
                        ghbApproveCreditPercent: ghbUsedBank.length > 0 ? ghbUsedBank[0].approveCreditPercent : "",
                        ghbCreditStatusId: ghbUsedBank.length > 0 ? this.setCreditStatus(ghbUsedBank[0].creditStatusId): "",
                        ghbCreditReasonStatusId: ghbUsedBank.length > 0 ? this.setCreditReasonStatus(ghbUsedBank[0].creditReasonStatusId) : "",
                        ghbCrRemarkBank: ghbUsedBank.length > 0 ? ghbUsedBank[0].crRemarkBank : "",
                        ghbRecoverDate: ghbUsedBank.length > 0 ? ghbUsedBank[0].recoverDate : "",
                        ghbApproveDate: ghbUsedBank.length > 0 ? ghbUsedBank[0].approveDate : "",

                        gsbUsedBankId: gsbUsedBank.length > 0 ? this.setUsedBank(gsbUsedBank[0]) : "",
                        gsbBankId: gsbUsedBank.length > 0 ? this.setBank(gsbUsedBank[0].bankId) : "",
                        gsbApproveFinanceAmt: gsbUsedBank.length > 0 ? this.setComma(gsbUsedBank[0].approveFinanceAmt) : "",
                        gsbInterest: gsbUsedBank.length > 0 ? gsbUsedBank[0].interest : "",
                        gsbApproveCreditPercent: gsbUsedBank.length > 0 ? gsbUsedBank[0].approveCreditPercent : "",
                        gsbCreditStatusId: gsbUsedBank.length > 0 ? this.setCreditStatus(gsbUsedBank[0].creditStatusId) : "",
                        gsbCreditReasonStatusId: gsbUsedBank.length > 0 ? this.setCreditReasonStatus(gsbUsedBank[0].creditReasonStatusId) : "",
                        gsbCrRemarkBank: gsbUsedBank.length > 0 ? gsbUsedBank[0].crRemarkBank : "",
                        gsbRecoverDate: gsbUsedBank.length > 0 ? gsbUsedBank[0].recoverDate : "",
                        gsbApproveDate: gsbUsedBank.length > 0 ? gsbUsedBank[0].approveDate : "",

                        uobUsedBankId: uobUsedBank.length > 0 ? this.setUsedBank(uobUsedBank[0]) : "",
                        uobBankId: uobUsedBank.length > 0 ? this.setBank(uobUsedBank[0].bankId) : "",
                        uobApproveFinanceAmt: uobUsedBank.length > 0 ? this.setComma(uobUsedBank[0].approveFinanceAmt) : "",
                        uobInterest: uobUsedBank.length > 0 ? uobUsedBank[0].interest : "",
                        uobApproveCreditPercent: uobUsedBank.length > 0 ? uobUsedBank[0].approveCreditPercent : "",
                        uobCreditStatusId: uobUsedBank.length > 0 ? this.setCreditStatus(uobUsedBank[0].creditStatusId) : "",
                        uobCreditReasonStatusId: uobUsedBank.length > 0 ? this.setCreditReasonStatus(uobUsedBank[0].creditReasonStatusId) : "",
                        uobCrRemarkBank: uobUsedBank.length > 0 ? uobUsedBank[0].crRemarkBank : "",
                        uobRecoverDate: uobUsedBank.length > 0 ? uobUsedBank[0].recoverDate : "",
                        uobApproveDate: uobUsedBank.length > 0 ? uobUsedBank[0].approveDate : "",

                        otherUsedBankId: otherUsedBank.length > 0 ? this.setUsedBank(otherUsedBank[0]) : "",
                        otherBankId: otherUsedBank.length > 0 ? this.setBank(otherUsedBank[0].bankId) : "",
                        otherApproveFinanceAmt: otherUsedBank.length > 0 ? this.setComma(otherUsedBank[0].approveFinanceAmt) : "",
                        otherInterest: otherUsedBank.length > 0 ? otherUsedBank[0].interest : "",
                        otherApproveCreditPercent: otherUsedBank.length > 0 ? otherUsedBank[0].approveCreditPercent : "",
                        otherCreditStatusId: otherUsedBank.length > 0 ? this.setCreditStatus(otherUsedBank[0].creditStatusId) : "",
                        otherCreditReasonStatusId: otherUsedBank.length > 0 ? this.setCreditReasonStatus(otherUsedBank[0].creditReasonStatusId) : "",
                        otherCrRemarkBank: otherUsedBank.length > 0 ? otherUsedBank[0].crRemarkBank : "",
                        otherRecoverDate: otherUsedBank.length > 0 ? otherUsedBank[0].recoverDate : "",
                        otherApproveDate: otherUsedBank.length > 0 ? otherUsedBank[0].approveDate : "",
                    }
                )
            })
        this.loading = false
        return dataItem
    }  

    setUsedBank (obj: any) {
        if (obj.usedBankId == "" || obj.usedBankId == 0) return false
        if (obj.bankId == "" || obj.bankId == 0) return false
        if (obj.usedBankId != obj.bankId) return false
        return true
    }

    setBank (bankId: any) {
        if (bankId == "" || bankId == 0) return ""
        return this.bankLists.filter(b => b.id == bankId)[0].name
    }

    setCreditStatus (id: any) {
        if (id == "" || id == 0) return ""
        return this.creditStatusLists.filter(b => b.id == id)[0].descriptionTH
    }

    setCreditReasonStatus (id: any) {
        if (id == "" || id == 0) return ""
        return this.creditReasonStatusLists.filter(b => b.id == id)[0].descriptionTH
    }

    setComma (amount: any) {
        if (amount == "" || amount == 0) return ""
        return amount.toLocaleString()
    }

    openNotification (text: string, status: string) {
        const child = this.$refs.refNotifcation as any
        child.openNotification(text, status)
    }

    changeState (key: string, value: string) {
        console.log('changeState =>', 'key', key, 'value',value)
        this.jsonData[key] = value
        console.log('jsonData =>', this.jsonData)
    }

    splitProjectCode (data: string) {
        if (data != "") return ""

        const [ project, unit ] = data.split("-")
        return `${project}`
        
    }
}


